export interface PledgeDto {
  PledgeId: number;
  PledgeCampaignId?: number;
  ProfileId?: number;
  StartDate?: Date;
  EndDate?: Date;
  PledgeLevel?: string;
  AssignedTo?: number;
  PledgeTotal?: number;
  PledgeYears?: number;
  Notes?: string;
  ItemNum?: number;
  BillingCycle?: string;
  Custom1: string;
  Custom2: string;
  Custom3: string;
  Custom4: string;
  Custom5: string;
  ReportName?: string;
  OrgInd?: boolean;
  Member?: boolean;
}

export enum BillingCycleName {
  Every12Months = 'Every 12 Months',
  Every6Months = 'Every 6 Months',
  Every3Months = 'Every 3 Months',
  EveryMonth = 'Every Month',
}
